export const FILTER_OPTIONS = [
  { label: 'Unread & Read', value: 'unread_read', filter: 'archived=false' },
  { label: 'Read', value: 'read', filter: 'unread=false&archived=false' },
  { label: 'Archived', value: 'archived', filter: 'archived=true' },
]

export const BADGE_MAX_DISPLAY = 99
export const BADGE_MAX_DISPLAY_LABEL = '99+'

export const RELATIVE_TIME_FALLBACK_DAYS = 7
export const ABSOLUTE_DATE_FORMAT = 'MMM D'

export const RELATIVE_TIME_LOCALE = {
  future: 'in %s',
  past: '%s ago',
  s: 'just now',
  m: '1 min',
  mm: '%d mins',
  h: '1 hr',
  hh: '%d hrs',
  d: '1 day',
  dd: '%d days',
  M: '1 mo',
  MM: '%d mos',
  y: '1 yr',
  yy: '%d yrs',
}
